module.exports = __webpack_public_path__ + "img/group-folder-icon.61a35e91.svg";